import { capitalize } from 'lodash';
/**
 * Parses a raw API error object and transforms it into a human-readable format
 * that conforms to the PrimeNG `Message` interface.
 *
 * @param {SailsResponse} apiError The raw error object from the API.
 * @returns {Message} A PrimeNG `Message` object, ready to be used with MessageService.
 */
export function parseApiErrorToMessage(apiError) {
    // 1. Find the core error string using optional chaining for safety.
    const rawErrorString = apiError?.data?.error || apiError?.response?.body?.error;
    // If we can't find the specific error string, return a generic error message.
    if (!rawErrorString) {
        return {
            severity: 'error',
            summary: 'An Unknown Error Occurred',
            detail: 'The server response could not be processed. Please try again.',
        };
    }
    // 2. Define regular expressions to extract key parts of the validation error.
    // const entityRegex = /Invalid attributes sent to (\w+):/;
    const validationRegex = /•\s*(\w+)\s*\n\s*•\s*"([^"]+)"\s*validation rule failed/;
    // 3. Attempt to parse the string.
    // const entityMatch = rawErrorString.match(entityRegex);
    const validationMatch = rawErrorString.match(validationRegex);
    // If we successfully parse the specific validation failure...
    if (validationMatch) {
        // const entity = entityMatch ? capitalize(entityMatch[1]) : 'Item';
        const fieldName = validationMatch[1]; // "sites"
        const rule = validationMatch[2]; // "required"
        let detailMessage = '';
        const friendlyFieldName = capitalize(fieldName);
        // 4. Translate the technical rule into a simple, helpful message.
        switch (rule.toLowerCase()) {
            case 'required':
                detailMessage = `The '${friendlyFieldName}' field is required and cannot be empty.`;
                break;
            case 'unique':
                detailMessage = `The value for '${friendlyFieldName}' is already taken. Please choose another.`;
                break;
            // Add other common rules here as needed.
            default:
                detailMessage = `There is a validation issue with the '${friendlyFieldName}' field.`;
                break;
        }
        return {
            severity: 'error',
            summary: 'Could not save',
            detail: detailMessage,
        };
    }
    // 5. Fallback for errors that don't match our specific validation format.
    return {
        severity: 'error',
        summary: 'Request Failed',
        detail: 'The server reported an unspecific error. Please check your inputs.',
    };
}
